module.exports = __webpack_public_path__ + "img/770421841.e0ed2e95.jpg";